/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: LinkMyLabel.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/26 @ 949
 * ---
 * Description:
 */

import {observer} from 'mobx-react';
import {Editor} from '../../store/observables/Editor';
import {useCallback} from 'react';
import {mleDomainGqlClient} from '../../api/domain';
import {CREATE_DATAORIGIN} from '../../api/domain/mutations.gql';
import {MleToaster, Toasts} from '../../common/toast';
import {DataOrigin, DataOriginType, OriginContentType} from '@revodigital/mle-dataresolver/lib/entities';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {MyLabelLoginForm} from '../forms/MyLabelLoginForm';
import {Intent} from '@blueprintjs/core';

interface Props {
    editor: Editor;
    onLinkSuccessful?: (dataOrigin: DataOrigin) => void;
}

export const LinkMyLabel = observer((props: Props) => {
    const authData = useSelector((state: RootState) => state.authState);

    const handleLinkCreate = useCallback(async () => {
      const dataOrigin = await mleDomainGqlClient.mutate({
        mutation: CREATE_DATAORIGIN,
        variables: {
          input: {
            type: DataOriginType.REMOTE,
            hasCredentials: true,
            resource: '',
            name: `MyLabel`,
            contentType: OriginContentType.MyLabel,
            companyId: authData.user.company?.id
          }
        }
      });

      props.editor.mylabelAuthFeature.setIsConnected(true);

      // Try to auto-select org and recipe
      const selection = await props.editor.recipeSwitcher.tryAutoSelect();

      if (selection)
        MleToaster.getInstance().show({
            message: `${selection.recipe.recipe_name} collegata al progetto`,
            intent: Intent.SUCCESS,
            icon: 'data-connection'
        },);
      else MleToaster.getInstance().show(Toasts.UNABLE_TO_CONNECT_RC);

      if (props.onLinkSuccessful)
        props.onLinkSuccessful(dataOrigin.data.addDataOrigin);
    }, []);

    return (
      <div>
        <MyLabelLoginForm editor={ props.editor }
                          onLoginSuccessful={ handleLinkCreate }
                          onLoginError={ () => {} }
        />
      </div>
    );
  })
;
